import { render, staticRenderFns } from "./UpdateSelfAsset.vue?vue&type=template&id=6c8d03e5&scoped=true"
import script from "./UpdateSelfAsset.vue?vue&type=script&lang=js"
export * from "./UpdateSelfAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d03e5",
  null
  
)

export default component.exports